import { render, staticRenderFns } from "./ModalAddPhone.vue?vue&type=template&id=498d81b3&scoped=true&"
import script from "./ModalAddPhone.vue?vue&type=script&lang=js&"
export * from "./ModalAddPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d81b3",
  null
  
)

export default component.exports